import React,{useState, useRef,useEffect} from "react";
import { InpDataList } from "@gull";
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios'
import SweetAlert from "sweetalert2-react";

const useSearchSupplementLists = (props) => {
    const [loadingSearchSupplementList,setLoadingSearchSupplementList]=useState(false)
    const [generalErrorSearchSupplementList,setGeneralErrorSearchSupplementList]=useState(false)
    const [listSearchSupplementList,setListSearchSupplementList]=useState([])
    const [datas,setDatas]=useState([])
    const searchInputSupplementList = useRef('')

    const loadSupplementLists = async (toSearch) => {
        setLoadingSearchSupplementList(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/get_by_name/"+toSearch
        ).then((response) => {
            setListSearchSupplementList(response.data.datas)
            let initial = []
            response.data.datas.forEach((value)=>
                initial.push({
                    id: value.id,
                    name: value.name
                })
            )
            setListSearchSupplementList(initial)
            let ajour = initial.filter((value)=>value.name.toLowerCase().includes(searchInputSupplementList.current.value.toLowerCase()))
            let temp = props.datas.supplement_list.map(value => value.name.toLowerCase())
            ajour = ajour.filter((value) => !temp.includes(value.name.toLowerCase()))
            setDatas(ajour)
            setLoadingSearchSupplementList(false)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchSupplementList(false)
            setGeneralErrorSearchSupplementList(true)
        })
    }

    return [loadingSearchSupplementList,loadSupplementLists,generalErrorSearchSupplementList,setGeneralErrorSearchSupplementList,listSearchSupplementList,datas,setDatas,searchInputSupplementList]
}

const InputSearchSupplementList = (props) =>{
    const t =useTranslate()
    const [loadingSearchSupplementList,loadSupplementLists,generalErrorSearchSupplementList,setGeneralErrorSearchSupplementList,listSearchSupplementList,datas,setDatas,searchInputSupplementList]=useSearchSupplementLists(props)

    const [supplementListName,setSupplementListName] = useState('')
    const [lastSearch,setLastSearch] = useState(false) 

    const dataListDropSupplementList = useRef('')

    const toggleAlertSearchSupplementList = () => {
        setGeneralErrorSearchSupplementList(false)
    }

    const handleSearch = (e,declenchement) => {
        setSupplementListName(e.target.value)
        if(e.target.value.length>=declenchement){
            dataListDropSupplementList.current.classList.remove("d-none");

            if(!lastSearch || e.target.value.substring(0, declenchement) != lastSearch.substring(0, declenchement)){
                loadSupplementLists(e.target.value.substring(0, declenchement))
                setLastSearch(e.target.value.substring(0, declenchement))
            }
        }else{
            dataListDropSupplementList.current.classList.add("d-none");
            setLastSearch(false)
        }
        if(e.target.value.length!=declenchement){
            let ajour = listSearchSupplementList.filter((value)=>value.name.toLowerCase().includes(e.target.value.toLowerCase()))
            setDatas(ajour)
        }
    }

    const handleCLick = (id,valeur) => {
        props.setSupplementListAdd(id)
        setSupplementListName(valeur)
    }

    return(
        <>
            <div className="position-relative">
                <InpDataList
                    placeholder={t('supplementListPlaceholder')}
                    value={supplementListName}
                    onClick={handleCLick}
                    onChange={handleSearch}
                    datas={datas}
                    declenchement={3}
                    listRef={dataListDropSupplementList}
                    inputRef={searchInputSupplementList}
                    disabled={props.disabled}
                    inputName="searchSupplementList"
                />
                {(loadingSearchSupplementList) ?
                    <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm topBarLeftPosition2"></div></span>
                :
                    false
                }
            </div>
            {(generalErrorSearchSupplementList) &&
                <SweetAlert show="true" title={t('unknowError')} type="error" onConfirm={() => toggleAlertSearchSupplementList()}/>
            }
        </>
    )
}

export default InputSearchSupplementList;